import { MappingList, Tooltip, TooltipProps } from '@silverfort/sf-components';
import React from 'react';

export type TotalMetricProps = {
    title: string;
    total: number;
    data: {
        name: string;
        value: number;
        fill: string;
        tooltipContent?: string;
        tooltipPlacement?: TooltipProps['placement'];
    }[];
    isLoading?: boolean;
    isError?: boolean;
};

const TotalMetric: React.FC<TotalMetricProps> = ({ title, total, data, isLoading = false, isError = false }) => {
    return (
        <div className="flex flex-col flex-1">
            <div className="flex flex-row items-center justify-between mb-2">
                <span className="text-12">{title}</span>
                <span className="text-13 font-bold">{total}</span>
            </div>
            <div className="flex w-full h-1 rounded overflow-hidden mb-3">
                {isLoading ? (
                    <div className="h-1 w-full bg-sf-gray-200 rounded"></div>
                ) : (
                    data.map((item, idx) => (
                        <div
                            key={`${item.name}-${idx}`}
                            className="mr-[2px] last:mr-0"
                            style={{
                                width: `${(item.value / total) * 100}%`,
                                backgroundColor: item.fill
                            }}>
                            <Tooltip placement="top" arrow key={item.name} title={item.tooltipContent}>
                                <div key={item.name} className="h-1" />
                            </Tooltip>
                        </div>
                    ))
                )}
            </div>
            <div className="flex flex-col">
                <MappingList
                    items={data.map((items) => {
                        return { ...items, value: `${((total ? items.value / total : 0) * 100).toFixed(2)}%` };
                    })}
                    isLoading={isLoading}
                />
            </div>
        </div>
    );
};

export default TotalMetric;
